module.exports = __webpack_public_path__ + "static/media/unauthorizedSC.e840dbd7.svg";